import FinanceReportsStatementOfAccount from './finance-reports-statement-of-account.container';

export default FinanceReportsStatementOfAccount;
